/**
 * Design tokens for responsive breakpoints
 * Following mobile-first approach
 */

export const breakpoints = {
  xs: '0px', // Extra small devices (phones)
  sm: '576px', // Small devices (landscape phones)
  md: '768px', // Medium devices (tablets)
  lg: '992px', // Large devices (desktops)
  xl: '1200px', // Extra large devices (large desktops)
  xxl: '1400px', // Extra extra large devices
} as const

// Container max widths for each breakpoint
export const containerMaxWidth = {
  xs: '100%',
  sm: '540px',
  md: '720px',
  lg: '960px',
  xl: '1140px',
  xxl: '1320px',
} as const

// Grid system
export const grid = {
  columns: 12,
  gutter: {
    xs: '16px',
    sm: '16px',
    md: '24px',
    lg: '24px',
    xl: '32px',
    xxl: '32px',
  },
} as const

// Media queries helpers
export const mediaQueries = {
  xs: `@media (min-width: ${breakpoints.xs})`,
  sm: `@media (min-width: ${breakpoints.sm})`,
  md: `@media (min-width: ${breakpoints.md})`,
  lg: `@media (min-width: ${breakpoints.lg})`,
  xl: `@media (min-width: ${breakpoints.xl})`,
  xxl: `@media (min-width: ${breakpoints.xxl})`,

  // Max width queries
  'max-xs': `@media (max-width: ${Number.parseInt(breakpoints.sm) - 1}px)`,
  'max-sm': `@media (max-width: ${Number.parseInt(breakpoints.md) - 1}px)`,
  'max-md': `@media (max-width: ${Number.parseInt(breakpoints.lg) - 1}px)`,
  'max-lg': `@media (max-width: ${Number.parseInt(breakpoints.xl) - 1}px)`,
  'max-xl': `@media (max-width: ${Number.parseInt(breakpoints.xxl) - 1}px)`,

  // Range queries
  'sm-only': `@media (min-width: ${breakpoints.sm}) and (max-width: ${Number.parseInt(breakpoints.md) - 1}px)`,
  'md-only': `@media (min-width: ${breakpoints.md}) and (max-width: ${Number.parseInt(breakpoints.lg) - 1}px)`,
  'lg-only': `@media (min-width: ${breakpoints.lg}) and (max-width: ${Number.parseInt(breakpoints.xl) - 1}px)`,
  'xl-only': `@media (min-width: ${breakpoints.xl}) and (max-width: ${Number.parseInt(breakpoints.xxl) - 1}px)`,
} as const

// Component responsive behavior
export const responsiveConfig = {
  // Navigation
  navigation: {
    mobileBreakpoint: breakpoints.md,
    collapsedWidth: '80px',
    expandedWidth: '256px',
  },

  // Tables
  table: {
    scrollBreakpoint: breakpoints.md,
    stackBreakpoint: breakpoints.sm,
  },

  // Forms
  form: {
    stackBreakpoint: breakpoints.sm,
    inlineBreakpoint: breakpoints.md,
  },

  // Cards
  card: {
    stackBreakpoint: breakpoints.sm,
    gridBreakpoints: {
      1: breakpoints.xs,
      2: breakpoints.sm,
      3: breakpoints.md,
      4: breakpoints.lg,
    },
  },
} as const

export type Breakpoint = keyof typeof breakpoints
export type MediaQuery = keyof typeof mediaQueries
